<template>
    <div class="wrapper">
      <div class="container">
        <app-header></app-header>
        <router-view :key="reload" />
      </div>
    </div>
</template>

<script>
     import appHeader from '../common/header'

    export default {
        name: 'defaultLayout',
        data() {
            return {
            }
        },
        components: {
             appHeader,
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
